/* eslint-disable */
export enum ApisStatusEnum {
  COMPLETE = 'COMPLETE',
  AGENT_REVAL_REQUIRED = 'AGENT_REVAL_REQUIRED',
  NOT_REQUIRED = 'NOT_REQUIRED',
  NOT_PERFORMED = 'NOT_PERFORMED',
  NOT_COMPLETE = 'NOT_COMPLETE'
}

